@if (showCalendarWeeks) {
    <ul class="week-number">
        @for (week of weekNumbers; track week) {
            <li>
                <span>{{ week }}</span>
            </li>
        }
    </ul>
}
<table
    class="owl-dt-calendar-table owl-dt-calendar-month-table"
    [ngClass]="{ 'owl-calendar-weeks': showCalendarWeeks }"
    [class.owl-dt-calendar-only-current-month]="hideOtherMonths"
>
    <thead class="owl-dt-calendar-header">
        <tr class="owl-dt-weekdays">
            @for (weekday of weekdays; track weekday.short) {
                <th
                    [attr.aria-label]="weekday.long"
                    class="owl-dt-weekday"
                    scope="col"
                >
                    <span>{{ weekday.short }}</span>
                </th>
            }
        </tr>
        <tr>
            <th
                class="owl-dt-calendar-table-divider"
                [ngClass]="{ 'owl-calendar-weeks': showCalendarWeeks }"
                aria-hidden="true"
                colspan="7"
            ></th>
        </tr>
    </thead>
    <tbody
        owl-date-time-calendar-body
        role="grid"
        [rows]="days"
        [todayValue]="todayDate"
        [selectedValues]="selectedDates"
        [selectMode]="selectMode"
        [activeCell]="activeCell"
        (keydown)="handleCalendarKeydown($event)"
        (select)="selectCalendarCell($event)"
    ></tbody>
</table>
